export const inputPaperSurface = (theme: {
    palette: { background: { paper: string } }
}) => ({
    '& .MuiOutlinedInput-root, & .MuiPickersOutlinedInput-root, & .MuiPickersInputBase-root':
        {
            backgroundColor: theme.palette.background.paper,
        },
    '& .MuiOutlinedInput-input, & .MuiPickersInputBase-input': {
        backgroundColor: 'transparent',
    },
})
